import React, {useContext} from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';
import logo from '../../assets/virtalibry_logo.png';
import {Context} from "../../index"; // путь к логотипу

const PoolPDFExport = ({ poolRef, imagesRef, activeFlags, poolItems }) => {
    const {poolStore, user} = useContext(Context);
    const handleDownload = async () => {

        const input = poolRef.current;
        if (!input) return;

        const canvas = await html2canvas(input, { scale: 2 });
        const canvas2 = await html2canvas(imagesRef.current, { scale: 2, useCORS: true, });
        const imgData = canvas.toDataURL('image/png');
        const logoImg = new Image();
        logoImg.src = logo;

        // часть (imagesRef)



        logoImg.onload = () => {
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();

            const pxToMm = (px) => px * 0.264583;
            const logoWidthMm = Math.min(pxToMm(logoImg.width), 50);
            const logoHeightMm = (logoImg.height / logoImg.width) * logoWidthMm;

            // Отступы
            const margin = 7;
            let currentY = 6;

            // Название
            pdf.setFont('helvetica', 'italic');
            pdf.setFontSize(14);
            pdf.setTextColor(80);// серый (muted)
            pdf.text(poolStore?.selectedPool?.name || 'Untitled Poll', margin, currentY + 5);

// Подзаголовок с датой
            const now = new Date();
            const day = String(now.getDate()).padStart(2, '0');
            const month = now.toLocaleString('en-US', { month: 'short' });
            const year = now.getFullYear();
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const formattedDate = `${day}-${month}-${year}, ${hours}:${minutes}`;

            pdf.setFontSize(9);
            pdf.setTextColor(80);
            pdf.text(`Report Generated on: ${formattedDate}, by ${user?.user?.username}`, margin, currentY + 12);

            // Логотип справа
            pdf.addImage(logo, 'PNG', pdfWidth - logoWidthMm - margin, currentY, logoWidthMm, logoHeightMm);

            // Смещаем вниз после логотипа
            currentY += logoHeightMm + 9;

            // Основное изображение (график, таблица и т.п.)
            const contentWidth = pdfWidth - margin * 2;
            const contentHeight = (canvas.height * contentWidth) / canvas.width;
            const img2 = canvas2.toDataURL('image/png');
            const contentHeight2 = (canvas2.height * contentWidth) / canvas2.width;
            pdf.setFontSize(12);
            pdf.text('Poll Choices Presented to Respondents:', margin, currentY + 5);
            // Смещаем вниз после логотипа
            currentY += logoHeightMm + 1;
            pdf.addImage(img2, 'PNG', margin, currentY, contentWidth, contentHeight2);
            currentY += contentHeight2 + 6;
            pdf.text('Chart View - How Respondents Voted:', margin, currentY + 5);
            // Смещаем вниз после логотипа
            currentY += logoHeightMm + 1;

            pdf.addImage(imgData, 'PNG', margin, currentY, contentWidth, contentHeight);
            currentY += contentHeight + 8;

            // new
            pdf.setFontSize(12);
            pdf.setTextColor(80);
            pdf.text('Table View - How Respondents Voted:', margin, currentY);
            currentY += 5;
            // Легенда
            pdf.setFontSize(9);
            pdf.setTextColor(100);
            pdf.text('W = Winner Star, O = Rated Star, . = Empty', margin, currentY);
            currentY += 3;

            const tableHead = [[
                'ID', 'User', 'Start', 'End', 'Status',
                ...activeFlags.map((_, i) => `Option #${i + 1}`)
            ]];

            const tableBody = poolItems.map((item, index) => {
                const userLabel = item?.respondent_name ? `${item.respondent_name.slice(0, 3)}***` : 'User';
                const start = item.start_date
                    ? new Date(item.start_date * 60000).toLocaleString('en-GB', {
                        day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false,
                    }) : '-';
                const end = item.end_date
                    ? new Date(item.end_date * 60000).toLocaleString('en-GB', {
                        day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false,
                    }) : '-';

                const statusLabel = item?.respondent_step === 'STEP0'
                    ? 'Waiting'
                    : item?.respondent_step === 'STEP1'
                        ? 'Started'
                        : item?.respondent_step === 'STEP2'
                            ? 'Completed'
                            : '-';

                const ratings = activeFlags.map((flag) => {
                    const ratingKey = `pool_item${flag}_rating`;
                    const isWinner = Number(item.winner) === flag;
                    const stars = Number(item[ratingKey]) || 0;
                    const starString = Array.from({ length: 5 }, (_, i) =>
                        i < stars
                            ? (isWinner ? 'W' : 'O')
                            : '.'
                    ).join('');
                    return starString;
                });


                return [index + 1, userLabel, start, end, statusLabel, ...ratings];
            });

            autoTable(pdf, {
                startY: currentY,
                head: tableHead,
                body: tableBody,
                margin: { left: margin, right: margin },
                styles: {
                    fontSize: 8,
                    cellPadding: { top: 1, bottom: 1, left: 1, right: 1 },
                    halign: 'center',
                    valign: 'middle',
                    overflow: 'linebreak',
                    lineWidth: 0.1,
                    lineColor: 200,
                },
                headStyles: {
                    fillColor: [22, 160, 133],
                    textColor: 255,
                    fontStyle: 'bold',
                },
                columnStyles: {
                    0: { cellWidth: 10 },
                    1: { cellWidth: 25 },
                    2: { cellWidth: 28 },
                    3: { cellWidth: 28 },
                    4: { cellWidth: 20 },
                    // остальные опции адаптируются автоматически
                },
            });

            currentY = pdf.lastAutoTable.finalY + 10;






            // Комментарии от респондентов (только STEP2)
            const allComments = [];

            poolItems.forEach((item, index) => {
                if (item.respondent_step !== 'STEP2') return;

                const user = item.respondent_name
                    ? `#${index + 1}, ${item.respondent_name.slice(0, 3)}***`
                    : `User ${index + 1}`;

                activeFlags.forEach((flag) => {
                    const comment = item[`pool_item${flag}_text`];
                    if (comment && comment.trim()) {
                        const isWinner = Number(item.winner) === flag;
                        allComments.push([
                            user,
                            `Option ${flag}${isWinner ? ' (Win)' : ''}`,
                            comment.length > 300 ? comment.slice(0, 300) + '…' : comment,
                        ]);
                    }
                });
            });

            if (allComments.length > 0) {
                pdf.setFont('helvetica', 'italic');
                pdf.setFontSize(13);
                pdf.setTextColor(120);
                pdf.text('Respondents Comments (Completed only)', margin, currentY);

                autoTable(pdf, {
                    startY: currentY + 5,
                    margin: { left: margin, right: margin },
                    head: [['User', 'Option', 'Comment']],
                    body: allComments,
                    styles: {
                        fontSize: 8,
                        cellPadding: { top: 1, bottom: 1, left: 1, right: 1 },
                        overflow: 'linebreak',
                        lineWidth: 0.1,
                        lineColor: 200,
                        halign: 'left', // базовое выравнивание для других колонок
                        valign: 'middle'
                    },
                    headStyles: {
                        fillColor: [22, 160, 133],
                        textColor: 255,
                        fontStyle: 'bold',
                        halign: 'center' // выравнивание заголовков
                    },
                    columnStyles: {
                        0: { cellWidth: 30, halign: 'center' },
                        1: { cellWidth: 30, halign: 'center' },
                        2: {
                            cellWidth: contentWidth - 60,
                            cellPadding: { top: 1, bottom: 1, left: 2, right: 2 }
                        }
                    }
                });

            }

            // Сохраняем PDF
            const fileName = `virtalibry_poll_${new Date().toISOString().slice(0, 10)}.pdf`;
            pdf.save(fileName);
        };
    };

    return (
        <button  className="btn btn-sm btn-outline-success d-none d-md-inline" onClick={handleDownload}>
            Download Full PDF Report
        </button>
    );
};

export default PoolPDFExport;
